import { getEditLocation } from "../../../core/util/functions";
export const deliveriesLocation = "/reports/deliveries";
export const getDeliveriesEditLocation = (id?: string) =>
  getEditLocation(deliveriesLocation, undefined, id);

export const editRouter = getDeliveriesEditLocation(":dlvrId?");
